import { TextInput, type TextInputProps } from '@mantine/core';
import { useEffect, useState } from 'react';
import { parseTime } from '@/lib/format';

interface Props extends Omit<TextInputProps, 'value' | 'onChange'> {
  /** Anzeige, z. B. „09:30“ */
  display: string;
  onCommit: (hours: number, minutes: number) => void;
}

/** Uhrzeit-Eingabe („930“, „9:30“, „9:30pm“); übernimmt bei Blur/Enter. */
export function TimeInput({ display, onCommit, ...rest }: Props) {
  const [text, setText] = useState(display);
  useEffect(() => setText(display), [display]);

  const commit = () => {
    const parsed = parseTime(text);
    if (!parsed) {
      setText(display);
      return;
    }
    onCommit(parsed[0], parsed[1]);
  };

  return (
    <TextInput
      value={text}
      onChange={(e) => setText(e.currentTarget.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        if (e.key === 'Escape') setText(display);
      }}
      onFocus={(e) => e.currentTarget.select()}
      {...rest}
    />
  );
}
